__turbopack_context__.v({
  "bar": "TJKf_G_bar",
  "percentage": "TJKf_G_percentage",
  "root": "TJKf_G_root",
});
